import AxiosClient from "../../../services/axios.services";

class KnowledgeAreasServices {
  getKnowledgeAreas = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_formacion_area_conocimiento/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getKnowledgeAreasById = (id) =>
    AxiosClient.get(
      `/api/app/descriptor_perfil_formacion_area_conocimiento/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveKnowledgeAreas = (data) =>
    AxiosClient.post(
      "/api/app/descriptor_perfil_formacion_area_conocimiento/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editKnowledgeAreas = (id, data) =>
    AxiosClient.put(
      `/api/app/descriptor_perfil_formacion_area_conocimiento/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteKnowledgeAreas = (id) =>
    AxiosClient.delete(
      `/api/app/descriptor_perfil_formacion_area_conocimiento/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new KnowledgeAreasServices();
